import { UIElements } from '@ansvar-sakerhet/ui';
import styled from 'styled-components';
import * as Dialog from '@radix-ui/react-dialog';

const Container = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  max-width: 1100px;
  margin-right: auto;
  margin-left: auto;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TableContainer = styled.div`
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  text-align: left;
  padding: 12px 8px;
  border-bottom: 1px solid #cbcbcb;
  font-weight: 600;
`;

const Td = styled.td`
  text-align: left;
  padding: 12px 8px;
  border-bottom: 1px solid #eee;
`;

const Overlay = styled(Dialog.Overlay)`
  background-color: rgba(0, 0, 0, 0.25);
  position: fixed;
  z-index: 200;
  inset: 0;
  display: grid;
  place-items: center;
  overflow-y: auto;
`;

const Content = styled(Dialog.Content)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  width: 480px;
  padding: 32px;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.15);
`;

const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CloseButton = styled(Dialog.Close)`
  cursor: pointer;
  background: none;
  border: none;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
`;

const Select = styled.select`
  padding: 16px 14px;
  border: 1px solid #cbcbcb;
  border-radius: 2px;
  font-size: 16px;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 400;
  color: #1b1b1b;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const RowActions = styled.div`
  display: flex;
  gap: 8px;
`;

const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
`;

export const S = {
  ...UIElements,
  Container,
  Header,
  TableContainer,
  Table,
  Th,
  Td,
  Overlay,
  Content,
  ContentHeader,
  CloseButton,
  Form,
  Select,
  Label,
  Field,
  Actions,
  RowActions,
  CheckboxGroup,
  CheckboxRow,
};
